import moment from 'moment'
import { Transform, Type } from 'class-transformer'

import { Employee } from './Employee'

type EventType = 'created' | 'updated' | 'scanned'

export class Event {
  data?: any

  get guid() {
    return `${this.type}.${this.on}.${this.by?.fullName}`
  }

  @Type(() => Employee)
  by?: Employee

  @Transform((value) => moment(value))
  on?: moment.Moment

  type?: EventType
}
